// extracted by mini-css-extract-plugin
module.exports = {"menu":"Menu_menu__2xbQm","active":"Menu_active__1d32I"};